import { useState } from "react";

const NumberInput = ({ initialCount, loading, onUpdateNumber }) => {
    const [number, setNumber] = useState(initialCount);

    const handleDecrease = () => {
        if (number > 0 && !loading) {
            onUpdateNumber(number - 1);
            setNumber(number - 1);
        }
    };

    const handleIncrease = () => {
        if (!loading) {
            onUpdateNumber(number + 1);
            setNumber(number + 1);
        }
    };

    return (
        <div className="d-flex align-items-center gap-2">
            <button
                className="btn btn-sm btn-primary"
                onClick={handleDecrease}
                disabled={number === 0 || loading}
                style={{ minWidth: 32 }}
            >-</button>
            <input
                type="text"
                className="form-control form-control-sm text-center p-1"
                value={number}
                readOnly
                style={{ width: 50, background: "#f8f9fa", border: "none" }}
            />
            <button
                className="btn btn-sm btn-primary"
                onClick={handleIncrease}
                disabled={loading}
                style={{ minWidth: 32 }}
            >+</button>
        </div>
    );
};

export default NumberInput;